<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>查询条件</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="getSalesRankingInfoManageInfo.conditions" class="flex justify-start">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form-item>
            <el-date-picker
              v-model="getSalesRankingInfoManageInfo.conditions.beginTime"
              type="datetime"
              placeholder="选择开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item>
                <el-date-picker
                  v-model="getSalesRankingInfoManageInfo.conditions.beginTime"
                  type="datetime"
                  placeholder="选择开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                />
          </el-form-item>
          <el-form-item>
            <el-date-picker
                  v-model="getSalesRankingInfoManageInfo.conditions.endTime"
                  type="datetime"
                  placeholder="选择结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                />
          </el-form-item>
          <el-form-item>
            <el-input
                  v-model="getSalesRankingInfoManageInfo.conditions.prodNameLike"
                  placeholder="请输入商品名称"
                  clearable
                />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryGetSalesRankingInfoMethod">
                <i class="el-icon-search"></i> 查询
              </el-button>
              <el-button @click="_resetGetSalesRankingInfoMethod">
                <i class="el-icon-refresh"></i> 重置
              </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-row style="margin-top: 20px">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>销售排行</span>
          </div>
          <el-table
            :data="getSalesRankingInfoManageInfo.getSalesRankingInfos"
            border
            style="width: 100%"
          >
            <el-table-column prop="productId" label="商品编号" align="center" />
            <el-table-column prop="prodName" label="商品名称" align="center" />
            <el-table-column prop="cartNum" label="销量" align="center">
              <template slot-scope="scope">
                {{ scope.row.cartNum || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="payPrice" label="销售金额" align="center">
              <template slot-scope="scope">
                {{ scope.row.payPrice || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="returnCartNum" label="退货数量" align="center">
              <template slot-scope="scope">
                {{ scope.row.returnCartNum || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="returnPayPrice" label="退货金额" align="center">
              <template slot-scope="scope">
                {{ scope.row.returnPayPrice || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center" />
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="getSalesRankingInfoManageInfo.total"
            style="margin-top: 20px; text-align: right"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getSalesRankingInfo } from '@/api/goods/salesRankingApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'GetSalesRankingInfoManage',
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      getSalesRankingInfoManageInfo: {
        getSalesRankingInfos: [],
        total: 0,
        records: 1,
        conditions: {
          beginTime: '',
          endTime: '',
          prodNameLike: '',
          shopId: ''
        }
      }
    }
  },
  created() {
    this.getSalesRankingInfoManageInfo.conditions.shopId = getShopId()
    this._listGetSalesRankingInfokings(this.currentPage, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listGetSalesRankingInfokings(this.currentPage, this.pageSize)
    },
    async _listGetSalesRankingInfokings(page, rows) {
      this.getSalesRankingInfoManageInfo.conditions.page = page
      this.getSalesRankingInfoManageInfo.conditions.row = rows
      const params = {
        ...this.getSalesRankingInfoManageInfo.conditions,
        prodNameLike: this.getSalesRankingInfoManageInfo.conditions.prodNameLike.trim()
      }

      try {
        const res = await getSalesRankingInfo(params)
        this.getSalesRankingInfoManageInfo.total = res.total
        this.getSalesRankingInfoManageInfo.records = res.records
        this.getSalesRankingInfoManageInfo.getSalesRankingInfos = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryGetSalesRankingInfoMethod() {
      this.currentPage = 1
      this._listGetSalesRankingInfokings(this.currentPage, this.pageSize)
    },
    _resetGetSalesRankingInfoMethod() {
      this.getSalesRankingInfoManageInfo.conditions.beginTime = ''
      this.getSalesRankingInfoManageInfo.conditions.endTime = ''
      this.getSalesRankingInfoManageInfo.conditions.prodNameLike = ''
      this._queryGetSalesRankingInfoMethod()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>